import React, { useEffect, useState } from 'react';
import { useAuth } from '@/modules/auth/ui/AuthProvider';
import AuthScreen from '@/modules/auth/ui/AuthScreen';

function AuthenticatePage() {
  const { user, loading } = useAuth();
  const [isProcessingAuth, setIsProcessingAuth] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  useEffect(() => {
    const hasTokens = new URLSearchParams(window.location.search).has('token');
    
    // If we have tokens, show processing state
    if (hasTokens && !user) {
      setIsProcessingAuth(true);
    }

    // If user is authenticated and we haven't shown success message yet
    if (user && !showSuccessMessage) {
      console.log('User authenticated, showing success message...');
      setShowSuccessMessage(true);
      setIsProcessingAuth(false);
    }
  }, [user, showSuccessMessage]);

  const handleContinueClick = () => {
    window.location.href = '/';
  };

  // Show loading state while processing authentication
  if (loading || isProcessingAuth) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 border-4 border-t-transparent border-purple-600 rounded-full animate-spin"></div>
          <span className="text-lg text-gray-600">
            {isProcessingAuth ? 'Signing you in...' : 'Loading...'}
          </span>
        </div>
      </div>
    );
  }

  // Show success message when user is authenticated
  if (user && showSuccessMessage) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center py-8 px-2 sm:py-12 sm:px-4">
        <div className="w-full max-w-sm sm:max-w-md lg:max-w-lg mx-auto">
          <div className="bg-white rounded-xl sm:rounded-2xl shadow-xl border border-gray-200 p-6 sm:p-8 text-center mx-2 sm:mx-0">
            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
              <svg className="w-6 h-6 sm:w-8 sm:h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">🎉 Welcome to the Waitlist!</h2>
            <p className="text-gray-600 mb-4 sm:mb-6 text-sm sm:text-base px-2">
              You're now signed in and on the waitlist for App Traction. We'll notify you via email when we launch.
            </p>
            <p className="text-xs sm:text-sm text-gray-500 mb-6 px-2">
              Signed in as: <span className="font-medium break-all">{user.email}</span>
            </p>
            
            <button 
              onClick={handleContinueClick}
              className="w-full bg-purple-600 text-white font-semibold py-3 px-6 rounded-lg hover:bg-purple-700 transition-colors"
            >
              Continue to App
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Show the authentication form
  return <AuthScreen />;
}

export default AuthenticatePage; 